
import React, { useEffect, useState } from 'react';
import './App.css';
import AllTogether from './Screen/AllTogether/AllTogether';

// import Axios from 'axios';
import { useNavigate } from 'react-router-dom';

const App = () => {

  const navigate = useNavigate()


// const [user, setUser] = useState(null);
// const [err, setError] = useState('');

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);


useEffect(()=>{
      // 1. Parse the URL to find the 'token' parameter
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

        if (token) {
      // 2. Store the token securely in localStorage or sessionStorage
      localStorage.setItem('token', token);
      setIsAuthenticated(true);

      // 3. Clean up the URL so the token isn't visible in the address bar
      // This changes '/dashboard?token=xyz' to just '/dashboard'
      navigate('/dashboard', { replace: true });
      setLoading(false);


    } else {
      // Check if they already have a token saved
      const existingToken = localStorage.getItem('token');
      if (existingToken) {

        setIsAuthenticated(true);
        setLoading(false);

      }else{
                // Redirect to login if no token is found anywhere
        window.location.href = 'https://fanonix.com/login';
        // window.location.href = 'http://localhost:3000/login';
      }
    }
}, [navigate]);

  if (loading) {
    return <div style={{
      textAlign:'center',
      fontFamily: 'sans-serif',
      fontSize:'13px',
      color:'#333',
      textTransform:'capitalize'
    }}>
      Verifying  Session...</div>;
  }

  return (
    <React.Fragment>

      <section style={{display: 'flex'}}>


        <AllTogether />


      </section>

    </React.Fragment>
  );
};


export default App;